import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

interface FundStrategiesProps extends MultiTableComponentProps {
  tableKey: string;
}

const columnLables = {
  hedge_fund_strategy_type: {
    name: 'Strategy'
  },
  primary_strategy_flag: {
    name: 'Is Primary?'
  },
  strategy_nav_rate: {
    name: '% of NAV'
  },
  strategy_type_other_description: {
    name: "Description of 'other' Strategy"
  }
};

export function FundStrategies({
  funds,
  currentDataKey,
  onChangeFund,
  tableKey,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: FundStrategiesProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data[tableKey],
    onChangeFund,
    schema: schema[tableKey],
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.[tableKey]?.field_names || [],
    tableName: tableKey,
    columnLables,
    order: 37 as any,
    isMultiFunds,
    funds,
    onAddColumn,
    onDeleteColumn
  });

  return (
    <Table
      id={`fca-reporttables-fund-strategies-${tableKey}-table`}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
